'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:module:tower:userCheckNickname');
}

var _invoke = require('../invoke');

/**
 *
 * 检查设置用户昵称
 *
 * http://wiki.sankuai.com/pages/viewpage.action?pageId=500753388
 *
 * 支持版本
 * + iTower/1.3+
 *
 * @memberof tower
 * @static
 * @name checkNickname
 * @return {Promise<string | err>}
 * @example
 *  hbnb.tower.checkNickname();
 */

module.exports = function() {
    return new Promise(function(resolve, reject) {
        _invoke('tower', 'user_check_nickname', {
            callback: function(result) {
                if (process.env.NODE_ENV !== 'production') {
                    debug('check nickname callback result is %j', result);
                }
                resolve(result);
            },
            errback: reject
        });
    });
};



//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/@hfe/hbnb/tower/user-check-nickname.js
// module id = 627
// module chunks = 0